import { addStyles } from 'ethcss'
import { colors, grid, indents, IStyles, mediaCSS } from 'theme'

const CARD_WIDTH = 600
const APP_LIST_HEIGHT = 230

export const styles: IStyles = {
    installedApplicationList: {
        height: `100%`,
        width: `100%`,
        ...grid.flex,
        ...grid.normalCenter,
        ...grid.center,
        padding: indents.normal,
        background: `rgba(0, 0, 0, 0.2)`,
    },
    installedApplicationList__close: {
        position: 'absolute',
        top: 20,
        right: 20,
    },
    installedApplicationList__card: {
        position: 'relative',
        width: CARD_WIDTH,
        maxHeight: 'none!important',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius: 20,
        height: '800px',

        [mediaCSS.tabMini]: {
            minHeight: 'auto',
        },
    },
    installedApplicationList__title: {
        paddingRight: `${indents.big}px!important`,
    },
    installedApplicationList__body: {
        padding: `${indents.mini}px ${indents.big}px`,
        [mediaCSS.tabMini]: {
            padding: 0,
        },
    },
    installedApplicationList__content: {
        height: APP_LIST_HEIGHT,
        overflow: 'auto',
    },
    scrollBlockWrapper: {
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        overflow: 'hidden',
        padding: 6,
    },
    installedApplicationList__item: {
        paddingBottom: indents.big,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    installedApplicationList__loader: {
        ...grid.flex,
        ...grid.center,
        ...grid.normalCenter,
        height: `100%`,
    },
    appsListContainer: {},
    appsListTable: {
        width: '100%',
    },
    appsListTableCell: {
        padding: '6px 0',

        '&:nth-child(1)': {
            width: '40%',
        },
        '&:nth-child(2)': {
            width: '26%',
        },
        '&:nth-child(3)': {
            width: '22%',
        },
    },
    infoText: {
        fontSize: 18,
        color: colors.grey,
        textAlign: 'center',
        marginBottom: 36,
    },
    listGap: {
        marginBottom: 40,
    },
    listTitle: {
        marginBottom: 10,
    },
    refreshWrapper: {
        display: 'flex',
        borderBottom: `1px solid ${colors.greyLight}`,
        marginBottom: 24,
        paddingBottom: 18,
    },
    activeAction: {
        color: colors.blueAccent,
        textDecoration: 'underline',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    modal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        padding: 40,
        borderRadius: 20,
        boxShadow: '0px 4px 4px 0px #00000040',
        maxWidth: 450,
        textAlign: 'center',
    },
    controls: {
        display: 'flex',
        justifyContent: 'center',
        margin: '40px auto 0 auto',
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        width: 120,
        margin: '0 10px',
    },
}

addStyles(styles)
